var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 57,
    viewBox: "0 0 84 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49598e-06 0.147688L21.5343 56.9654L33.3935 24.4397L26.4154 5.44675C26.0325 4.17105 24.7166 0.955031 21.965 0.442081C20.3858 0.147698 16.635 -0.00983014 12.2028 0.000475506C7.85194 0.0105918 3.08167 0.00185669 4.49598e-06 0.147688Z",
    fill: "#BFD2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5342 56.9654C21.5342 56.9654 39.5751 7.19574 40.4122 5.32155C41.2492 3.44737 44.5514 0.197095 46.9015 0C53.7086 0 63.7326 0 63.7326 0C67.3763 0.0986414 76.7952 1.82595 81.7542 12.1329C87.6629 24.4137 80.5724 34.6231 75.8454 38.7661C75.6882 38.9039 70.0844 43.5008 60.7782 43.5008C51.472 43.5008 50.7334 42.761 48.5176 47.6438C46.3019 52.5265 45.8587 56.9654 41.5749 56.9654H21.5342Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogo);
export default __webpack_public_path__ + "static/media/navLogo.cc9e8a7cbbf5240d5c42a1b4285583f7.svg";
export { ForwardRef as ReactComponent };